import * as React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickAriaProps } from '../../interfaces/commonProps';
import { StyledText } from './Text.styles';
import { textPropTypes } from './Text.types';
export const Text = React.forwardRef(function Text({ 'data-testid': testingId, as = 'p', children, className, id, variant = 'copy1', weight = 'normal', ...restProps }, ref) {
    const passthroughProps = {
        'data-testid': testingId,
        as,
        className,
        id,
        outerSpacing: useSpacing(restProps),
        variant,
        weight,
    };
    return (React.createElement(StyledText, { ref: ref, ...passthroughProps, ...pickAriaProps(restProps) }, children));
});
Text.propTypes = textPropTypes;
//# sourceMappingURL=Text.js.map